module.exports = __webpack_public_path__ + "assets/img/type_6.f88160d1.png";